// Firebase initialization for web
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyDIm2jMEhD1XNYedDw_aytT5h9VmI-53f4",
  authDomain: "cuattendance.firebaseapp.com",
  projectId: "cuattendance",
  storageBucket: "cuattendance.appspot.com",
  messagingSenderId: "258399963493",
  appId: "1:258399963493:web:a239268ab8c723c2b0b98c",
  measurementId: "G-098MG4FT6Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

export default app;
